import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityTiposRolLoadFailure,
  entityTiposRolLoadSuccess,
  entityTiposRolLoadRequest,
} from './entity-tipos-rol.actions';
import { TiposRolService } from '@rpe/registro-personas-empresas-lib/src/lib/tipos-rol/tipos-rol.service';

@Injectable()
export class TiposRolEffects {
  // load
  loadRequestTiposRol = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTiposRolLoadRequest),
      mergeMap(() =>
        this.tiposRolServiceService.getTiposRol().pipe(
          map((items) => entityTiposRolLoadSuccess({ items })),
          catchError((error) => of(entityTiposRolLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private tiposRolServiceService: TiposRolService
  ) {
    this.tiposRolServiceService.url = environment.apiUrl;
  }
}
